export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana19.f021f74b.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};